import { Component, OnInit } from '@angular/core';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { GlobalService } from './../../core/global.service';
import { TaskService } from './../task.service';

@Component({
  selector: 'app-user-tasks',
  templateUrl: './user-tasks.component.html',
  styleUrls: ['./user-tasks.component.scss'],
  animations: [
    trigger('balloonEffect', [
      state('initial', style({
        transform: 'scale(0)'
      })),
      state('final', style({
        transform: 'scale(1)'
      })),
      transition('initial=>final', animate('500ms'))
    ])
  ]
})

export class UserTasksComponent implements OnInit {

  taskData: any;
  dataReceived: boolean;
  currentState = 'initial';

  constructor( private _global: GlobalService, private taskService: TaskService) { }

  ngOnInit() {
    this.taskData = {};
    this.dataReceived = false;
    this.taskService.getCanCompleteTasksCounter().subscribe(response => {
      if (response.data.length > 0) {
        this.dataReceived =  true;
        this.taskData = response.data[0];
        setTimeout(() => {
          this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
        }, 50);
      }
    });
  }

  navigateToInbox(): void {
    const route = `${(<any>_GlobalNS).api.person.noteAlterts}`;
    this._global.document.location.href = route;
  }

  navigateToWorkFLow(): void {
    const route = `${(<any>_GlobalNS).routes.workflow.myCompletableTasks}`;  
    this._global.document.location.href = route;
  }

}
